const _excluded = ["children", "className", "required", "testId", "inputProps", "menuMaxHeight", "menuMaxWidth", "skin", "SelectProps", "helperText", "value", "onChange", "isSelected"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { forwardRef } from 'react';
import { TextField as MuiTextField } from '@material-ui/core';
import cn from 'classnames';
import { WideArrowDownward } from "../../icons";
import { BottomSheetContentLayout } from "../BottomSheet";
import { useDevice } from "../Device";
import { useOverlayContext } from "../OverlayContext";
import { Tooltip } from "../Tooltip";
import { skinToColor, useInlineSelectStyles } from "./InlineSelect.styles";
import { jsx as _jsx } from "react/jsx-runtime";
function InlineSelectBottomSheet(props) {
  const {
    children,
    value,
    onChange,
    isSelected
  } = props;
  const {
    hideBottomSheet
  } = useOverlayContext();
  return /*#__PURE__*/_jsx(BottomSheetContentLayout, {
    children: React.Children.map(children, child => {
      if (! /*#__PURE__*/React.isValidElement(child)) return child;
      const childProps = child.props;
      return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, childProps), {}, {
        selected: isSelected ? isSelected(childProps.value, value) : childProps.value === value,
        onClick: () => {
          onChange === null || onChange === void 0 || onChange({
            target: {
              value: childProps.value
            }
          });
          hideBottomSheet();
        }
      }));
    })
  });
}
export const InlineSelect = /*#__PURE__*/forwardRef(function InlineSelect(props, ref) {
  var _props$InputProps;
  const {
      children,
      className,
      required,
      testId,
      inputProps,
      menuMaxHeight = 300,
      menuMaxWidth,
      skin = 'standard',
      SelectProps,
      helperText,
      value,
      onChange,
      isSelected
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    isMobileDevice
  } = useDevice();
  const {
    pushBottomSheetPage
  } = useOverlayContext();
  const overrides = useInlineSelectStyles({
    menuMaxHeight,
    menuMaxWidth,
    color: skinToColor[skin],
    isMobileDevice
  });
  const mobileSelectProps = isMobileDevice ? {
    open: false,
    onOpen: openMobileSheet
  } : {};
  function openMobileSheet() {
    pushBottomSheetPage({
      content: /*#__PURE__*/_jsx(InlineSelectBottomSheet, {
        value: value,
        onChange: onChange,
        isSelected: isSelected,
        children: children
      })
    });
  }
  const textField = /*#__PURE__*/_jsx(MuiTextField, _objectSpread(_objectSpread({
    innerRef: ref,
    value: value,
    onChange: onChange
  }, rest), {}, {
    "data-testid": testId,
    select: true,
    className: cn(className, overrides.root),
    variant: "standard",
    size: "small",
    helperText: undefined,
    InputProps: {
      ref: (_props$InputProps = props.InputProps) === null || _props$InputProps === void 0 ? void 0 : _props$InputProps.ref,
      required,
      classes: {
        root: overrides.inputRoot,
        input: overrides.inputInput
      }
    },
    SelectProps: _objectSpread(_objectSpread({
      IconComponent: _ref => {
        let {
          className
        } = _ref;
        return /*#__PURE__*/_jsx(WideArrowDownward, {
          width: "16px",
          height: "16px",
          className: cn(className, overrides.icon)
        });
      },
      MenuProps: {
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left'
        },
        getContentAnchorEl: null,
        classes: {
          paper: overrides.menu
        },
        ['data-testid']: testId && "".concat(testId, "-backdrop")
      },
      SelectDisplayProps: {
        ['data-testid']: testId && "".concat(testId, "-select")
      }
    }, SelectProps), mobileSelectProps) // eslint-disable-line @typescript-eslint/no-explicit-any
    ,
    inputProps: _objectSpread({
      ['data-testid']: testId && "".concat(testId, "-input")
    }, inputProps),
    children: children
  }));
  return helperText ? /*#__PURE__*/_jsx(Tooltip, {
    placement: "top",
    title: helperText,
    testId: testId && "".concat(testId, "-tooltip"),
    children: textField
  }) : textField;
});